import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { DateFormatterService } from 'src/app/shared/components/date-picker/date-formatter.service';
import { CaseService } from 'src/app/shared/services/case.service';
import { LookupService } from 'src/app/shared/services/lookup.service';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { SharedHttpService } from 'src/app/shared/services/shared-http.service';

@Component({
  selector: 'app-violation',
  templateUrl: './violation.component.html',
  styleUrls: ['./violation.component.scss']
})
export class ViolationComponent implements OnInit {
  MainViolationsArr: any;
  eCaseId: any;
  ViolationsArr: any;
  mainViolationTypeId: any;
  subViolationTypeId: any;
  SubViolationsArr: any;
  MainViolation: any;
  SubViolation: any;
  ViolationDescription: any;
  isAdd: boolean = false;
  SubViolationDescription: any;
  Place: any;
  quantity: any;
  InitalValue: any;
  Location: any;
  measurmentunitArr: any;
  measurmentUnitId: any;
  otherMeasurmentUnit: any;
  violationactionArr: any;
  violationactionId: any;
  otherAction: any;
  material: any;
  reachingViolationsMehod: any;
  purchaseSource: any;
  dateOfBuy: any
  ViolationIdDelete: any;
  violationIdEdit: any;
  isInsert:boolean=false;
  editedDate: { day: number; month: number; year: number; };
  mainViolationTypeName: any;
  subViolationTypeName: any;
  constructor(private dateformat: DateFormatterService, private sharedService: SharedHttpService, public route: Router, public lookupService: LookupService, public toastr: NotificationService, public caseService: CaseService) { }
  today = new Date();
  currentDate:NgbDateStruct;
  @Input() loadDataFP: Observable<any>;
  ngOnInit(): void {
    this.currentDate=this.sharedService.convertDateToNgbDateStruct(this.today);

      this.loadDataFP.subscribe((data) => {
          setTimeout(() => {
              this.loadData();
          }, 100);

      });

}

  loadData() {
    this.eCaseId = this.caseService.case.eCaseId;
    this.measurmentunitArr = this.lookupService.getLockup('measurmentunit');
    this.violationactionArr = this.lookupService.getLockup('violationaction');

    this.isAdd = false;
    this.isInsert = false;

    this.getMainViolation();
    this.sharedService.get(`api/Violation/GetCaseViolations?eCaseId=${this.eCaseId}`).subscribe(res => {
      this.ViolationsArr = res;
    });
  }
  SelectedDateChange($event) {
    this.dateOfBuy = this.dateformat.ToGregorian2($event);
  }

 
  getMainViolation() {
      this.sharedService.get(`api/Violation/GetMainViolations?CaseTypeId=${this.caseService.case.caseTypeId}`).subscribe(res => {
      this.MainViolationsArr = res;
    });
  }
  getSubViolation(e) {
    this.mainViolationTypeId = e.violationTypeId;
    this.sharedService.get(`api/Violation/GetSubViolations?ViolationTypeId=${this.mainViolationTypeId}`).subscribe(res => {
      this.SubViolationsArr = res;

    });
  }
  getSubViolationDesc(e) {
    this.SubViolationDescription = e.violationDescription;
  }
 

  numberOnly(event) {
    var inp = String.fromCharCode(event.keyCode);
    let pattern = /^\d+$/;
    if (pattern.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }
  CreateViolation(modal) {
    this.isInsert=true;
    this.mainViolationTypeId = undefined;
    this.subViolationTypeId = undefined;
    this.otherAction = undefined;
    this.Location = undefined;
    this.Place = undefined;
    this.quantity = undefined;
    this.InitalValue = undefined;
    this.measurmentUnitId =undefined;
    this.otherMeasurmentUnit = undefined;
    this.violationactionId = undefined;
    this.material = undefined;
    this.reachingViolationsMehod = undefined;
    this.currentDate=this.sharedService.convertDateToNgbDateStruct(this.today);
    this.dateOfBuy = this.dateformat.ToGregorian2(this.currentDate );
     
    // this.dateOfBuy = undefined;
    this.purchaseSource =undefined;

    this.sharedService.openLarge(modal);
  }
  
  onCreateViolation(modal) {
    let url = 'api/Violation/Insert';
    let objectAdded = {
      "caseId": this.caseService.case.caseId,
      "mainViolationTypeId": this.mainViolationTypeId,
      "subViolationTypeId": this.subViolationTypeId,
      "otherAction": this.otherAction,
      "location": this.Location,
      "place": this.Place,
      "quantity": this.quantity,
      "initalValue": this.InitalValue,
      "measurmentUnitId": this.measurmentUnitId,
      "otherMeasurmentUnit": this.otherMeasurmentUnit,
      "violationActionId": this.violationactionId,
      "material": this.material,
      "reachingViolationsMehod": this.reachingViolationsMehod,
      "dateOfBuy": this.dateOfBuy,
      "purchaseSource": this.purchaseSource,
    }

    this.sharedService.post(url, [objectAdded]).subscribe(
      (response) => {
        modal.dismiss('Cross click');
        this.loadData();
        this.sharedService.showSuccessKey("CreatedSuccessfully");

      },

    );
  }

  EditViolation(violation, modal) {
    this.isInsert=false;
    this.violationIdEdit = violation.violationId;
    this.getMainViolation();
    this.mainViolationTypeId = violation.mainViolationTypeId;
    this.sharedService.get(`api/Violation/GetSubViolations?ViolationTypeId=${this.mainViolationTypeId}`).subscribe(res => {
      this.SubViolationsArr = res;
    });
    this.subViolationTypeId = violation.subViolationTypeId;
    this.otherAction = violation.otherAction;
    this.Location = violation.location;
    this.Place = violation.place;
    this.quantity = violation.quantity;
    this.InitalValue = violation.initalValue;
    this.measurmentUnitId = violation.measurmentUnitId;
    this.otherMeasurmentUnit = violation.otherMeasurmentUnit;
    this.violationactionId = violation.violationActionId;
    this.material = violation.material;
    this.reachingViolationsMehod = violation.reachingViolationsMehod;
    this.dateOfBuy = violation.dateOfBuy;
    this.editedDate = this.sharedService.convertDateToNgbDateStruct(this.dateOfBuy);
    this.purchaseSource = violation.purchaseSource;
    this.mainViolationTypeName = violation.mainViolationTypeName;
    this.subViolationTypeName = violation.subViolationTypeName;
    this.sharedService.openLarge(modal);

  }

  onEditViolation(modal) {
    let url = 'api/Violation/Update';
    let objectAdded = {
      "caseId": this.caseService.case.caseId,
      "violationId":this.violationIdEdit,
      "mainViolationTypeId": this.mainViolationTypeId,
      "subViolationTypeId": this.subViolationTypeId,
      "otherAction": this.otherAction,
      "location": this.Location,
      "place": this.Place,
      "quantity": this.quantity,
      "initalValue": this.InitalValue,
      "measurmentUnitId": this.measurmentUnitId,
      "otherMeasurmentUnit": this.otherMeasurmentUnit,
      "violationActionId": this.violationactionId,
      "material": this.material,
      "reachingViolationsMehod": this.reachingViolationsMehod,
      "dateOfBuy": this.dateOfBuy,
      "purchaseSource": this.purchaseSource,
    }

    this.sharedService.put(url, [objectAdded]).subscribe(
      (response) => {
        modal.dismiss('Cross click');
        this.loadData();
        this.sharedService.showSuccessKey("EditedSuccessfully");

      },

    );
  }

  DeleteViolation(Id: any, mymodal) {
    this.sharedService.openSmall(mymodal);
    this.ViolationIdDelete = Id;

  }

  onDeleteViolation(modal) {
    let url = 'api/Violation/Delete';
    this.sharedService.delete(url, [this.ViolationIdDelete]).subscribe(
      (response) => {
        modal.dismiss('Cross click');
        this.sharedService.showSuccessKey("DeletedSuccessfully");
        this.loadData();
      },

    );
  }

}
